export default class UnifiedSignupEmailType {
  public readonly emailType: string;

  public static readonly genEmail = new UnifiedSignupEmailType({ val: 'generic' });

  public static readonly nonGenEmail = new UnifiedSignupEmailType({ val: 'non-generic' });

  private static mappings: Record<string, UnifiedSignupEmailType> = {
    generic: UnifiedSignupEmailType.genEmail,
    'non-generic': UnifiedSignupEmailType.nonGenEmail,
  };

  private constructor({
    val,
  }: {
    val: string,
  }) {
    this.emailType = val;
  }

  public compareTo(rhs: UnifiedSignupEmailType) {
    return this.emailType === rhs.emailType;
  }

  public static fromString(val: string) {
    const emailType = UnifiedSignupEmailType.mappings[`${val}`];
    if (!emailType) throw new Error(`Could not find email type with val: '${val}'`);
    return emailType;
  }
}
